import { configureFilterButton } from '@grapes-agency/ui'

import classes from './FilterButton.module.scss'

export const FilterButton = configureFilterButton({ classes })
